export const namespaces = {
  common: "common",
  aria: "aria",
  clsLogging: "clsLogging",
  validation: "validation",
  termsAndConditions: "termsAndConditions",
  routes: "routes",
  gdpr: "gdpr",
};

export const languages = {
  da: "da",
  en: "en",
};
